export const IconReconciliation = ({
  color = "#e51c00",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M10.5 0.5H9.5L6.5 3.5L9.5 6.5H10.5V4.5H12V10.208C11.117 10.5938 10.5 11.4748 10.5 12.5C10.5 13.8807 11.6193 15 13 15C14.3807 15 15.5 13.8807 15.5 12.5C15.5 11.4748 14.883 10.5938 14 10.208V2.5H10.5V0.5Z"
          fill={color}
        ></path>{" "}
        <path
          d="M6.5 15.5L9.5 12.5L6.5 9.5H5.5V11.5H4V5.79198C4.88295 5.4062 5.5 4.52516 5.5 3.5C5.5 2.11929 4.38071 1 3 1C1.61929 1 0.5 2.11929 0.5 3.5C0.5 4.52516 1.11705 5.4062 2 5.79198V13.5H5.5V15.5H6.5Z"
          fill={color}
        ></path>{" "}
      </g>
    </svg>
  );
};
